import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_CUSTOMER_ISSUES, GET_CUSTOMER_ISSUES_SUCCESS, GET_CUSTOMER_ISSUES_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getCustomerIssues({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/issues`,
      method: 'POST',
      headers: { ...filteredHeaders },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: GET_CUSTOMER_ISSUES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_CUSTOMER_ISSUES_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CUSTOMER_ISSUES_ERROR, payload: error });
  }
}

export function* watchGetCustomerIssues() {
  yield takeEvery(GET_CUSTOMER_ISSUES, getCustomerIssues);
}

function* getCustomerIssuesSaga() {
  yield all([fork(watchGetCustomerIssues)]);
}

export default getCustomerIssuesSaga;
